module.exports = "<div *ngIf=\"isLoading\">\r\n  <div class=\"preloader-backdrop\">\r\n      <!-- For Hiding Background details from User -->\r\n  </div>\r\n  <div class=\"preloader-container\" >\r\n      <span class=\"preloader\">\r\n           <img src=\"{{'assets/images/themes/'+theme+'/reload.gif'}}\" />\r\n          <!-- <i class=\"fa fa-spin fa-spinner fa-3x\"></i> -->\r\n      </span>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/preloader/preloader.component.html
// module id = ../../../../../src/app/core/components/preloader/preloader.component.html
// module chunks = main